<template>
	<div class="income column-me">
		<div class="tab-div row-me">
			<div class="item-tab column-me row-center" @click="clickTab(0)">
				<div class="tab-title" :class="{'tab-title-active':tabIndex===0}">收入汇总</div>
				<div class="tab-line" :class="{'tab-line-active':tabIndex===0}"></div>
			</div>
			<div class="item-tab column-me row-center" @click="clickTab(1)">
				<div class="tab-title" :class="{'tab-title-active':tabIndex===1}">收入明细</div>
				<div class="tab-line" :class="{'tab-line-active':tabIndex===1}"></div>
			</div>
			<div class="item-tab column-me row-center" @click="clickTab(2)">
				<div class="tab-title" :class="{'tab-title-active':tabIndex===2}">销售明细</div>
				<div class="tab-line" :class="{'tab-line-active':tabIndex===2}"></div>
			</div>
		</div>
		<!-- 收入汇总 -->
		<div class="card-div column-me flex1" v-show="tabIndex===0">
			<div class="row-me row-center">
				<div class="width300">
					<el-date-picker type="date" placeholder="请选择" format="YYYY-MM" value-format="YYYY-MM"
						style="width: 100%;" v-model="selectDate1">
					</el-date-picker>
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
					<el-icon>
						<search />
					</el-icon>
					查询
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickPrint">
					<el-icon>
						<printer />
					</el-icon>
					打印
				</div>
				<div class="btn-orange width100 btn-height40 margin-left20" @click="clickExport">导出</div>
			</div>
			<div class="table-border margin-top20">
				<div class="column-me">
					<div>
						<el-table :data="tableData1" border header-cell-class-name="table-header-style"
							cell-class-name="table-cell-style" height="68vh" show-summary>
							<el-table-column prop="date" label="日期" align="center"></el-table-column>
							<el-table-column prop="week" label="星期" align="center"></el-table-column>
							<el-table-column prop="dayTotal" label="当日汇总" align="center"></el-table-column>
							<el-table-column prop="zyFei" label="药品费" align="center"></el-table-column>
							<el-table-column prop="jiaGongFei" label="加工费" align="center"></el-table-column>
							<el-table-column prop="baoCaiFei" label="包材费" align="center"></el-table-column>
							<el-table-column prop="yunFei" label="运费" align="center"></el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!-- 收入明细 -->
		<div class="card-div column-me flex1" v-show="tabIndex===1">
			<div class="row-me row-center">
				<div class="width230">
					<el-date-picker type="date" placeholder="请选择" format="YYYY-MM" value-format="YYYY-MM"
						style="width: 100%;" v-model="selectDate2">
					</el-date-picker>
				</div>
				<div class="width230 margin-left20">
					<el-input placeholder="处方订单号" style="width: 100%;" clearable v-model="number"></el-input>
				</div>
				<div class="width230 margin-left20">
					<el-input placeholder="医院处方号" style="width: 100%;" clearable v-model="preOrder"></el-input>
				</div>
				<div class="width230 margin-left20">
					<el-input placeholder="医院名称" style="width: 100%;" clearable v-model="hospital"></el-input>
				</div>
				<div class="width230 margin-left20">
					<el-input placeholder="患者姓名" style="width: 100%;" clearable v-model="name"></el-input>
				</div>
				<div class="flex1"></div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
					<el-icon>
						<search />
					</el-icon>
					查询
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickPrint">
					<el-icon>
						<printer />
					</el-icon>
					打印
				</div>
				<div class="btn-orange width100 btn-height40 margin-left20" @click="clickExport">导出</div>
			</div>
			<div class="table-border margin-top20">
				<div class="column-me">
					<div>
						<el-table :data="tableData2" border header-cell-class-name="table-header-style"
							cell-class-name="table-cell-style" height="68vh" show-summary
							:summary-method="getSummaries">
							<el-table-column prop="createTime" label="处方时间" align="center" width="220">
							</el-table-column>
							<el-table-column prop="orderNo" label="处方订单号" align="center" width="250"></el-table-column>
							<el-table-column prop="prescriptionNumber" label="医院处方号" align="center" width="250">
							</el-table-column>
							<el-table-column prop="patientName" label="患者姓名" align="center" width="100">
							</el-table-column>
							<el-table-column prop="patientMobile" label="电话号码" align="center" width="150">
							</el-table-column>
							<el-table-column prop="hospitalName" label="医院名称" align="center" width="150">
							</el-table-column>
							<el-table-column prop="deliveryType" label="配送方式" align="center" width="100">
							</el-table-column>
							<el-table-column prop="totalPrice" label="应收汇总" align="center" width="100">
							</el-table-column>
							<el-table-column label="收款明细" align="center">
								<el-table-column prop="zyFee" label="药品费" align="center" width="120">
								</el-table-column>
								<el-table-column prop="processFee" label="加工费" align="center"></el-table-column>
								<el-table-column prop="packageFee" label="包材费" align="center"></el-table-column>
								<el-table-column prop="freightFee" label="运费" align="center"></el-table-column>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!-- 销售明细 -->
		<div class="card-div column-me flex1" v-show="tabIndex===2">
			<div class="row-me row-center">
				<div class="width350">
					<el-input placeholder="处方订单号" style="width: 100%;" clearable v-model="number3"></el-input>
				</div>
				<div class="width350 margin-left20">
					<el-input placeholder="医院处方号" style="width: 100%;" clearable v-model="preOrder3"></el-input>
				</div>
				<div class="width350 margin-left20">
					<el-input placeholder="患者姓名" style="width: 100%;" clearable v-model="name3"></el-input>
				</div>
				<div class="width350 margin-left20">
					<el-input placeholder="医院名称" style="width: 100%;" clearable v-model="hospital3"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="width350">
					<el-input placeholder="项目名称" style="width: 100%;" clearable v-model="project"></el-input>
				</div>
				<div class="width350 margin-left20">
					<el-date-picker type="date" placeholder="请选择" format="YYYY-MM" value-format="YYYY-MM"
						style="width: 100%;" v-model="selectDate3">
					</el-date-picker>
				</div>
				<div class="flex1"></div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
					<el-icon>
						<search />
					</el-icon>
					查询
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickClear">
					<el-icon>
						<delete />
					</el-icon>
					清空
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickPrint">
					<el-icon>
						<printer />
					</el-icon>
					打印
				</div>
				<div class="btn-orange width100 btn-height40 margin-left20" @click="clickExport">导出</div>
			</div>
			<div class="table-border margin-top20">
				<div class="column-me">
					<div>
						<el-table :data="tableData3" border header-cell-class-name="table-header-style"
							cell-class-name="table-cell-style" height="62vh" show-summary
							:summary-method="getSummaries1">
							<el-table-column prop="createTime" label="传方日期" align="center" width="220">
							</el-table-column>
							<el-table-column prop="orderNo" label="处方订单号" align="center" width="250"></el-table-column>
							<el-table-column prop="prescriptionNumber" label="医院处方号" align="center" width="200">
							</el-table-column>
							<el-table-column prop="patientName" label="患者姓名" align="center"></el-table-column>
							<el-table-column prop="hospitalName" label="医院名称" align="center"></el-table-column>
							<el-table-column prop="projectName" label="项目名称" align="center"></el-table-column>
							<el-table-column prop="unit" label="单位" align="center"></el-table-column>
							<el-table-column prop="saleNums" label="销售数量" align="center"></el-table-column>
							<el-table-column prop="costUnitPrice" label="成本单价" align="center"></el-table-column>
							<el-table-column prop="costTotalPrice" label="成本总额" align="center"></el-table-column>
							<el-table-column prop="saleUnitPrice" label="销售单价" align="center"></el-table-column>
							<el-table-column prop="saleTotalPrice" label="销售总额" align="center"></el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>

		<!-- 打印 -->
		<div v-show="false">
			<incomePrint ref="printPage" :printTitle="printTitle" :printType="printType" :tableData='printData'>
			</incomePrint>
		</div>
	</div>
</template>

<script>
	import incomePrint from './incomePrint.vue'
	export default {
		components: {
			incomePrint
		},
		data() {
			return {
				tabIndex: 0,
				selectDate1: '',
				tableData1: [],
				selectDate2: [],
				number: '',
				preOrder: '',
				hospital: '',
				name: '',
				tableData2: [],
				number3: '',
				preOrder3: '',
				name3: '',
				hospital3: '',
				project: '',
				selectDate3: '',
				tableData3: [],
				printTitle: '',
				printType: '',
				printData: [],
			}
		},
		// html加载完成之前
		created() {
			this.selectDate1 = this.$method.getNowYearMonth()
			this.selectDate2 = this.$method.getNowYearMonth()
			this.selectDate3 = this.$method.getNowYearMonth()
		},
		// html加载完成后执行。
		mounted() {
			this.getData()
		},
		// 事件方法执行
		methods: {
			//获取数据
			getData() {
				if (this.tabIndex === 0) {
					this.getIncomeSum()
				} else if (this.tabIndex === 1) {
					this.getIncomeDetail()
				} else if (this.tabIndex === 2) {
					this.getSaleDetail()
				}
			},
			clickTab(index) {
				this.tabIndex = index
				this.getData()
			},
			clickSearch() {
				this.getData()
			},
			clickPrint() {
				this.printType = this.tabIndex
				if (this.tabIndex === 0) {
					this.printTitle = '营业收入统计-收入汇总'
					let tempArray = this.$method.deepClone(this.tableData1)
					let sum = {
						"date": "总计",
						"week": "",
						"dayTotal": this.$method.countTotal(tempArray, 'dayTotal'),
						"zyFei": this.$method.countTotal(tempArray, 'zyFei'),
						"jiaGongFei": this.$method.countTotal(tempArray, 'jiaGongFei'),
						"baoCaiFei": this.$method.countTotal(tempArray, 'baoCaiFei'),
						"yunFei": this.$method.countTotal(tempArray, 'yunFei'),
					}
					tempArray.push(sum)
					this.printData = tempArray
				} else if (this.tabIndex === 1) {
					this.printTitle = '营业收入统计-收入明细'
					let tempArray = this.$method.deepClone(this.tableData2)
					let sum = {
						"createTime": "总计",
						"orderNo": "",
						"prescriptionNumber": '',
						"patientName": "",
						"patientMobile": "",
						"hospitalName": "",
						"totalPrice": this.$method.countTotal(tempArray, 'totalPrice'),
						"zyFee": this.$method.countTotal(tempArray, 'zyFee'),
						"processFee": this.$method.countTotal(tempArray, 'processFee'),
						"packageFee": this.$method.countTotal(tempArray, 'packageFee'),
						"freightFee": this.$method.countTotal(tempArray, 'freightFee'),
					}
					tempArray.push(sum)
					this.printData = tempArray
				} else if (this.tabIndex === 2) {
					this.printTitle = '营业收入统计-销售明细'
					let tempArray = this.$method.deepClone(this.tableData3)
					let sum = {
						costTotalPrice: this.$method.countTotal(tempArray, 'costTotalPrice'),
						costUnitPrice: this.$method.countTotal(tempArray, 'costUnitPrice'),
						createTime: "总计",
						hospitalName: "",
						orderNo: "",
						patientName: "",
						prescriptionNumber: '',
						projectName: "",
						saleNums: this.$method.countTotal(tempArray, 'saleNums'),
						saleTotalPrice: this.$method.countTotal(tempArray, 'saleTotalPrice'),
						saleUnitPrice: this.$method.countTotal(tempArray, 'saleUnitPrice'),
						unit: "",
					}
					tempArray.push(sum)
					this.printData = tempArray
				}
				this.$refs.printPage.startPrint()
			},
			clickExport() {
				let token = sessionStorage.getItem('token')
				if (this.tabIndex === 0) {
					let param = {
						time: this.selectDate1,
						token: token,
					}
					let url = this.$baseUrl + '/admin/statistics/incomeTotalDetailExport?' + this.$method.getParamsString(
						param)
					window.open(url)
				} else if (this.tabIndex === 1) {
					let param = {
						time: this.selectDate2,
						orderNo: this.number,
						prescriptionNumber: this.preOrder,
						hospitalName: this.hospital,
						patientName: this.name,
						token: token,
					}
					let url = this.$baseUrl + '/admin/statistics/incomeDetailExport?' + this.$method.getParamsString(param)
					window.open(url)
				} else if (this.tabIndex === 2) {
					let param = {
						time: this.selectDate3,
						orderNo: this.number3,
						prescriptionNumber: this.preOrder3,
						hospitalName: this.hospital3,
						patientName: this.name3,
						projectName: this.project,
						token: token,
					}
					let url = this.$baseUrl + '/admin/statistics/incomeSaleDetailExport?' + this.$method.getParamsString(
						param)
					window.open(url)
				}
			},
			clickClear() {
				this.number3 = ''
				this.preOrder3 = ''
				this.name3 = ''
				this.hospital3 = ''
				this.project = ''
				this.selectDate3 = this.$method.getNowYearMonth()
				this.getData()
			},
			//获取收入汇总
			getIncomeSum() {
				this.$postFormRequest('/admin/statistics/incomeTotalDetail', {
					time: this.selectDate1
				}).then((res) => {
					if (res) {
						this.tableData1 = res.data
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			//获取收入明细
			getIncomeDetail() {
				this.$postFormRequest('/admin/statistics/incomeDetail', {
					time: this.selectDate2,
					orderNo: this.number,
					prescriptionNumber: this.preOrder,
					hospitalName: this.hospital,
					patientName: this.name,
				}).then((res) => {
					if (res) {
						this.tableData2 = res.data
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			//获取销售明细
			getSaleDetail() {
				this.$postFormRequest('/admin/statistics/incomeSaleDetail', {
					time: this.selectDate3,
					orderNo: this.number3,
					prescriptionNumber: this.preOrder3,
					hospitalName: this.hospital3,
					patientName: this.name3,
					projectName: this.project,
				}).then((res) => {
					if (res) {
						this.tableData3 = res.data
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			// 收入明细合计
			getSummaries({
				columns,
				data
			}) {
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if (index > 6) {
						let values = []
						//静态表头
						if (column.property) {
							values = data.map(item => Number(item[column.property]));
						}
						//动态表头
						else {
							values = data.map(function(currentValue, index1, arr) {
								return currentValue.typeVos[index - 14].total //减去前边静态的列数
							})
						}
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + value;
								} else {
									return prev;
								}
							}, 0);
							sums[index] = this.$method.toFixed(sums[index], 3)
						} else {
							sums[index] = 'N/A';
						}
					}
				});
				return sums;
			},
			// 销售明细合计
			getSummaries1({
				columns,
				data
			}) {
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if (index > 6) {
						let values = []
						//静态表头
						if (column.property) {
							values = data.map(item => Number(item[column.property]));
						}
						//动态表头
						else {
							values = data.map(function(currentValue, index1, arr) {
								return currentValue.typeVos[index - 14].total //减去前边静态的列数
							})
						}
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + value;
								} else {
									return prev;
								}
							}, 0);
							sums[index] = this.$method.toFixed(sums[index], 3)
						} else {
							sums[index] = 'N/A';
						}
					}
				});
				return sums;
			},
		},
		// 计算属性
		computed: {

		},
		// 侦听器
		watch: {

		},
	}
</script>

<style lang="scss" scoped>
	.income {
		height: 100%;

		.tab-div {
			height: 60px;
			background: #FFFFFF;
			margin: 20px 20px 0 20px;
			padding-left: 50px;

			.item-tab {
				height: 60px;
				justify-content: flex-end;
				margin-right: 50px;

				.tab-title {
					font-size: 18px;
					color: #252630;

					&-active {
						color: #215AA0;
					}
				}

				.tab-line {
					width: 20px;
					height: 4px;
					background: #FFFFFF;
					border-radius: 1px;

					&-active {
						background: #215AA0;
					}
				}
			}
		}

		.card-div {
			margin: 20px;
			background: #FFFFFF;
			box-shadow: 0 0 5px #F3F3F3;
			border-radius: 3px;
			padding: 20px;
			font-size: 18px;
			color: #252630;
		}
	}
</style>
